var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h1',[_vm._v("404 Not Found")]),_c('p',[_vm._v("The page or resource you're looking for does not exist.")]),_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v("Home page with menu")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }